import React from "react";
import styled from "styled-components";
import TextView from "../../../components/TextView";
import Button from "../../../components/Button";
import Icon from "assets/images/balance.svg";
import { colors } from "../../../utils";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 26.57px 17.71px;
  gap: 26.52px;
  background-color: #f0f9ff;
  border-radius: 8.86px;
  height: 100%;
`;

const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 8.86px;
`;

const Image = styled.img`
  width: 31px;
  height: 31px;
`;

const BalanceText = styled(TextView)`
  width: 100%;
  font-family: "DM Sans", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 35.42px;
  line-height: 35px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  color: #123051;
  margin: 0 auto;
`;

const HeaderText = styled(TextView)`
  font-family: "DM Sans", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 15.5px;
  line-height: 22px;
  color: #565556;
`;

const ExplanationText = styled(TextView)`
  width: 100%;
  font-family: "DM Sans", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16.6px;
  line-height: 22px;
  display: flex;
  align-items: center;
  color: #123051;
`;

const ButtonView = styled.div`
  display: flex;
  margin-top: 40px;
  align-items: center;
  justify-content: space-between;
`;

export default function WithdrawCard({
  balance,
  onClick,
  onShowPaymentDetails,
}) {
  return (
    <Wrapper>
      <HeaderRow>
        <Image src={Icon} />
        <HeaderText>Account Balance</HeaderText>
      </HeaderRow>

      <BalanceText>${balance}</BalanceText>

      <ExplanationText>
        Balances under $10 are held over until next payout.
      </ExplanationText>

      {/* <ButtonView>
      <Button
        onClick={onClick}
        variant={"secondary"}
        style={{
          border: "0.5px solid #7FC9FA",
          backgroundColor: "#D3EDFE",
          width: 100,
          height:36,
          fontSize:14,
          marginRight:5
        }}
      >
        Withdraw
      </Button>
      </ButtonView> */}
    </Wrapper>
  );
}
